import React from "react";
import {auth} from "../../firebase";
import {useDispatch} from "react-redux";
import {openAlert} from "../../slices/alert";
import {openDialog} from "../../slices/dialog";
import Button from "../../components/Common/Button";
import ChangeEmail from "../../components/Dialog/ChangeEmail";
import {useTranslation} from "react-i18next";

const CompanySettings = () => {
    const dispatch = useDispatch();
    const account = auth.currentUser;
    const {t} = useTranslation();

    const onVerifyAccount = () => {
        const currentUser = auth.currentUser;
        if (currentUser)
            currentUser
                .sendEmailVerification()
                .then(() => {
                    dispatch(openAlert({type: "success", message: t("alert_email_sent")}));
                })
                .catch((error) => {
                    dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
                });
    };

    const onChangeEmail = () => {
        dispatch(
            openDialog({
                Content: ChangeEmail,
                title: t("company_settings_changeEmail_title"),
                closable: true,
            })
        );
    };

    return (
        <div className="companySettings">
            {/* Verifica account */}
            {!account?.emailVerified && (
                <div className="verifyButton">
                    <Button onClick={() => onVerifyAccount()}>{t("company_settings_verifyBtn")}</Button>
                </div>
            )}

            {/* Cambio email */}
            {<Button onClick={() => onChangeEmail()}>{t("company_settings_changeEmailBtn")}</Button>}
        </div>
    );
};

export default CompanySettings;
